<template>
  <div>
    <div class="main-content">
      <div class="section__content section__content--p30">
        <div class="container-fluid job-info-container">
          <v-card class="p-b-40 p-t-30 p-l-30 p-r-30 m-b-40">
            <div class="el-loading-mask" v-if="loading">
              <div class="el-loading-spinner">
                <svg viewBox="25 25 50 50" class="circular">
                  <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                </svg>
              </div>
            </div>
            <!-- Name -->
            <div class="row">
              <div class="col-md-9 header">
                <h3 class="title-7 p-b-10">
                  <v-btn
                    text
                    icon
                    class="m-0"
                    @click="$router.back()">
                    <i class="zmdi zmdi-long-arrow-left"></i>
                  </v-btn>
                  {{ endpoint.name }}
                  <v-btn
                    text
                    icon
                    class="m-0"
                    @click.stop="goToEdit()">
                    <i class="zmdi zmdi-edit grey--text" style="font-size: 1.4rem;"></i>
                  </v-btn>
                </h3>
              </div>
              <div class="col-md-3 text-right">
                <v-btn
                  v-if="endpoint.disabled"
                  color="success"
                  flat
                  @click="toggledEndpoint(false)"
                  class="mr-3 white--text">
                  <i class="fa fa-play p-r-10"></i> {{ text('enable_btn') }}
                </v-btn>
                <v-btn
                  v-if="!endpoint.disabled"
                  color="error"
                  flat
                  @click="toggledEndpoint(true)"
                  class="mr-3 white--text">
                  <i class="fa fa-stop p-r-10"></i> {{ text('disable_btn') }}
                </v-btn>
                <v-btn
                  color="error"
                  @click="isDeleteConfirmationDialogOpen = true"
                  class="m-0 white--text">
                  <i class="fa fa-trash p-r-10"></i> {{ text('delete_btn') }}
                </v-btn>
              </div>
            </div>
            <v-divider></v-divider>
            <!-- Status and general Info -->
            <div class="row">
              <div class="col-md-2">
                <div class="info-title">
                  <i class="zmdi zmdi-file-text p-r-5"></i>
                  ID
                </div>
                <div>
                  {{ endpoint.id }}
                </div>
              </div>
              <div class="col-md-5">
                <div class="info-title">
                  <i class="zmdi zmdi-calendar p-r-10"></i> {{ text('created') }}
                </div>
                <div>
                  {{ formatTime(endpoint.created) }}
                </div>
              </div>
              <div class="col-md-5">
                <div class="info-title">
                  <i class="zmdi zmdi-calendar p-r-10"></i> {{ text('updated') }}
                </div>
                <div>
                  {{ formatTime(endpoint.updated) }}
                </div>
              </div>
            </div>
            <v-divider></v-divider>
            <div class="row">
              <div class="col-md-12">
                <table class="job-output m-t-50">
                  <tbody>
                  <tr>
                    <td class="column-title">
                      {{ text('state') }}:
                    </td>
                    <td>
                      <span v-if="!endpoint.disabled">
                        <i class="fa fa-exclamation-circle job-status--failed"
                           v-if="endpoint.state === 'error'">
                        </i>
                        <i class="fa fa-check-circle job-status--finished"
                           v-else-if="endpoint.state === 'ok'">
                        </i>
                        <i class="fa fa-clock job-status--paused"
                           v-else>
                        </i>
                        {{ endpoint.state }}
                      </span>
                      <span v-else>
                        <i class="fa fa-stop-circle job-status--failed"></i>
                        {{ text('disabled') }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="endpoint.error && endpoint.state !== 'ok'">
                    <td class="column-title">
                      {{ text('error') }}:
                    </td>
                    <td class="column-error">
                      {{ endpoint.error }}
                    </td>
                  </tr>
                  <tr>
                    <td class="column-title">
                      {{ text('origin_URL') }}:
                    </td>
                    <td>
                      <a :href="endpoint.originURL" target="_blank">{{ endpoint.originURL }}</a>
                    </td>
                  </tr>
                  <tr>
                    <td class="column-title">
                      Endpoint URL:
                    </td>
                    <td>
                      <a :href="endpoint.url" target="_blank">{{ endpoint.url }}</a>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <i class="fa fa-lock p-r-5"></i>
                      {{ text('whitlist_list') }}:
                    </td>
                    <td>
                      <ul>
                        <li v-for="(subnet, i) of endpoint.ipWhitelist" :key="i">
                          {{ subnet.ip }}
                        </li>
                      </ul>
                      <span v-if="endpoint.ipWhitelist && endpoint.ipWhitelist.length === 0"
                            class="text--secondary">
                        {{ text('no_whitelist') }}
                      </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </v-card>

          <!-- Stat -->
          <!--v-card class="m-t-10 m-b-50 p-b-30 p-t-30 p-l-30 p-r-30">
            <div class="row">
              <div class="col-md-6">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateFormatted"
                      label="Date"
                      hint="MM/DD/YYYY format"
                      persistent-hint
                      prepend-icon="event"
                      @blur="date = parseDate(dateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
                </v-menu>
                <p>Date in ISO format: <strong>{{ date }}</strong></p>
              </div>
              <div class="col-md-6">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedDateFormatted"
                      label="Date (read only text field)"
                      hint="MM/DD/YYYY format"
                      persistent-hint
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title @input="menu2 = false"></v-date-picker>
                </v-menu>
                <p>Date in ISO format: <strong>{{ date }}</strong></p>
              </div>
            </div>
          </v-card-->
        </div>
      </div>
    </div>

    <!-- Remove Dialog -->
    <v-dialog v-model="isDeleteConfirmationDialogOpen" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">
          {{ text('confirm_deletion') }}
        </v-card-title>
        <v-card-text>
          <div class="row p-b-20">
            <div class="col-md-12">
              <v-text-field
                v-model.trim="confirmTitle"
                :label="text('enter_endpoint')"
                :rules="[rules.required]"
                counter>
              </v-text-field>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed small text
                 @click="isDeleteConfirmationDialogOpen = false">{{ text('no_btn') }}</v-btn>
          <v-btn depressed
                 small
                 color="error"
                 :disabled="!isTitleCheckPassed"
                 @click="deleteEndpoint">{{ text('yes_btn') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import { JsonAPIEndpointToNorm } from '@/components/cdn/shared/converter';

export default {
  data: vm => ({
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    menu2: false,
    //
    endpoint: {},
    isDeleteConfirmationDialogOpen: false,
    confirmTitle: '',
    rules: {
      required: value => !!value || this.text('required'),
    },
  }),
  computed: {
    loading() {
      return this.$store.getters.isDataLoaded;
    },
    isTitleCheckPassed() {
      return this.confirmTitle === this.endpoint.name;
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    dict() {
      return this.$store.getters.dictionary;
    },
  },
  beforeCreate() {
    this.$store.commit('setPageLoader');
  },
  created() {
    const endpointId = this.$route.params.id;
    this.$store.dispatch('endpoints/getCDNEndpoint', endpointId)
      .then((endpoint) => {
        this.endpoint = JsonAPIEndpointToNorm(endpoint);
      })
      .catch(() => {
        this.$router.push({ name: 'EndpointListPage' });
      })
      .finally(() => this.$store.commit('resolvePageLoader'));
  },
  methods: {
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    formatTime(time) {
      return moment(time).utc().format('MMM D, YYYY HH:mm') + ' UTC';
    },
    goToEdit() {
      this.$router.push({
        name: 'EndpointEditPage',
        params: {
          id: this.endpoint.id,
        },
      });
    },
    deleteEndpoint() {
      const endpointId = this.endpoint.id;
      this.$store.dispatch('endpoints/removeCDNEndpoint', endpointId)
        .then(() => {
          this.$toasted.success(this.text('endpoint_remove_popup'), {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 5000,
          });
          this.$router.push({ name: 'EndpointListPage' });
        })
        .catch((errorMsg) => {
          this.$toasted.error(errorMsg, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 7000,
          });
        });
    },
    toggledEndpoint(disabled) {
      const params = {
        id: this.endpoint.id,
        disabled,
      };
      this.$store.dispatch('endpoints/updateCDNEndpoint', params)
        .then(() => {
          this.$toasted.success(this.text('save_changes_popup'), {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 5000,
          });
          this.endpoint.disabled = !this.endpoint.disabled;
        })
        .catch((errorMsg) => {
          this.$toasted.error(errorMsg, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 7000,
          });
        });
    },
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return code;
    },
  },
};
</script>
